import { render, staticRenderFns } from "./goods-service-mult.vue?vue&type=template&id=0cb311ec&scoped=true&"
import script from "./goods-service-mult.vue?vue&type=script&lang=js&"
export * from "./goods-service-mult.vue?vue&type=script&lang=js&"
import style0 from "./goods-service-mult.vue?vue&type=style&index=0&id=0cb311ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb311ec",
  null
  
)

export default component.exports